import type { DevToolsHealthStatus } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsPanel/index.types';

/**
 * SIP registration state as a traffic light.
 *
 * Anything that is not registered and not on its way there is an error: an
 * unregistered softphone cannot take a call, however calm the status word looks.
 */
export const getSipHealthStatus = (
  status: string
): Exclude<DevToolsHealthStatus, 'idle'> => {
  if (status === 'registered') return 'healthy';
  if (status === 'connecting' || status === 'registering') return 'warning';

  return 'error';
};
